/**
 * Mapea los datos de los comprobantes contables desde la API al formato esperado por la UI.
 * 
 * @param {Array} data - Array de comprobantes devuelto por la API.
 * @returns {Array} Array de comprobantes formateados.
 */
export const mapAccountingVouchers = (data) => {
    if (!Array.isArray(data)) return [];

    return data.map(v => ({
        ...v,
        lineas: (v.lines || []).map(l => ({
            ...l,
            users_accounts: l.user_account ? {
                ...l.user_account,
                account: l.user_account.base_account ? {
                    ...l.user_account.base_account
                } : null
            } : null
        }))
    }));
};
